// eslint-disable-next-line
import React from 'react';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { StatusLabel } from '../StatusLabel';
import * as PXBColors from '@brightlayer-ui/colors';

type IOStatusBadgeProps = { isUpperCase?: boolean; };

export const IOStatusBadgeOpen: React.FC<React.PropsWithChildren<IOStatusBadgeProps>> = ({ isUpperCase = true }) => {
    const { t } = useLanguageLocale();

    return (
        <StatusLabel
            status={t('DRY_CONTACT.IOSTATUS.ENABLED')}
            foregroundColor={PXBColors.white[50]}
            backgroundColor={PXBColors.red[500]}
            testId="dry-contact-io-open-status-label"
            isUpperCase={isUpperCase}
        />
    );
};
